export enum NotesProjects {
  KBA = 'KBAs',
  NOTES = 'SAP Notes'
}
